import { useMutation } from '@apollo/client';

export default useMutation;
